// extracted by mini-css-extract-plugin
export default {"format":"Item_format__u22KO","checkbox":"Item_checkbox__MmCwR","nameAndPrice":"Item_nameAndPrice__YuKQm","from":"Item_from__tkamj"};